/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment/moment";
// import CustomTable from "../../../../components/common/Table";
// import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
// import StatusIcon from "../../../../assets/svg/Status";
import Table from "../../../../components/common/new/Table/Table";
// import { FRIEND_SEAECH_TABLE_COL } from "../../../../contants/table/friendReportSearch";
// import tableStyle from "../../../../theme/styles/table";
// import DeleteIcon from "../../../../assets/svg/Delete";
// import EyeIcon from "../../../../assets/svg/Eye";
// import { PERMISSIONS } from "../../../../contants";
import styles from "./FriendsReportsTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";
// import NewTable from "../../../member/components/Newtable/NewTable";
import { getSubDivisionDisplayName } from "../../../../utils/helper";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const FRIEND_SEAECH_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Friend ID",
    key: "id",
  },
  {
    displayName: "Name",
    // key: ["memberName", "memberAddress"],
    key: "fullName",
  },
  // {
  //   displayName: "Phone & Email",
  //   key: ["phone", "email"],
  // },
  {
    displayName: "Division/Sub Division",
    key: "division",
  },
  {
    displayName: "Date of First Meeting",
    key: "dateOfFirstMeeting",
  },
  {
    displayName: "Introduced By",
    key: "introducedBy",
  },
  {
    displayName: "Org Structure",
    key: "orgstructure",
  },
  // {
  //   displayName: "Area",
  //   key: "area",
  // },
  // {
  //   displayName: "Zone",
  //   key: "zone",
  // },
  // {
  //   displayName: "Region",
  //   key: "region",
  // },
  // {
  //   displayName: "Chapter",
  //   key: "chapter",
  // },
  // {
  //   displayName: "District",
  //   key: "district",
  // },
  // {
  //   displayName: "Block",
  //   key: "block",
  // },
  // {
  //   displayName: "Status",
  //   key: "status",
  // },
  //   {
  //     displayName: "Action",
  //     key: "action",
  //   },
];

const getRows = ({
  searchData,
  currentPage,
  pageSize,
  //   onSelectMember,
  //   onSelectMemberForTransfer,
  //   hasPermission,
  // showStatusColumn,
  // onMemberStatusToggle,
}) =>
  searchData.map((friendInfo, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    return (
      <TableRow>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.friendId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.fullName}
          </Typography>{" "}
          {/* <br />
          <div style={styles.tableBox}>
            <LocationOnIcon style={tableStyle.locationIcon} />{" "}
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {friendInfo.addressLine1}
              </Typography>
            </div>
          </div> */}
        </TableCell>
        {/* <TableCell style={tabelCellWidth.medium}>
          <PhoneIcon style={tableStyle.icon} />
          <Typography style={styles.typoghrphyStyle}>
            {" "}
            {friendInfo.mobileNumber}
          </Typography>{" "}
          <br />
          <div style={styles.tableBox}>
            {" "}
            <EmailIcon style={tableStyle.icon} />
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.emailId || "-"}
            </Typography>{" "}
          </div>
        </TableCell> */}
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {`${friendInfo?.divisionName || "-"} / ${
                getSubDivisionDisplayName(friendInfo?.subDivisionName) || "-"
              }`}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          {friendInfo.createdAt
            ? moment(friendInfo?.createdAt).format("DD/MM/YYYY")
            : "NA"}
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          {friendInfo.introducedByName || "-"}
          <br />
          {friendInfo.introducedByMobileNumber}
          <br />
          {friendInfo.introducedByEmail}
        </TableCell>
        {/* <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.subDivisionName || "-"}{" "}
            </Typography>
          </div>
        </TableCell> */}
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {`${friendInfo?.orgStructure.areaName || "-"} / ${
                friendInfo?.orgStructure.clusterName || "-"
              } / ${friendInfo?.orgStructure.zoneName || "-"}/ ${
                friendInfo?.orgStructure.regionName || "-"
              } / ${friendInfo?.orgStructure.chapterName || "-"} / ${
                friendInfo?.orgStructure.districtName || "-"
              }`}
            </Typography>{" "}
          </div>
        </TableCell>
        {/* <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.areaName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.zoneName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.regionName || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.chapterName || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.districtName || "-"}
            </Typography>{" "}
          </div>
        </TableCell> */}
        {/* <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.blockName || "-"}{" "}
            </Typography>
          </div>
        </TableCell> */}
        {/* {showStatusColumn && (
          <TableCell style={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              <StatusIcon label={friendInfo.status} />
            </div>
          </TableCell>
        )} */}
        {/* {showStatusColumn && (
          <>
            <TableCell style={tabelCellWidth.medium}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.mobileNumber || "-"}{" "}
                </Typography>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <Typography style={styles.typoghrphyStyle}>
                  {`${friendInfo?.address.addressLine || "-"} / ${
                    friendInfo?.address.cityName || "-"
                  } / ${friendInfo?.address.stateName || "-"}`}
                </Typography>{" "}
              </div>
            </TableCell>
          </>
        )} */}
      </TableRow>
    );
  });

function ReportTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  hasPermission,
  showStatusColumn,
}) {
  const columns = showStatusColumn
    ? FRIEND_SEAECH_TABLE_COL
    : FRIEND_SEAECH_TABLE_COL.filter(
        (c) => c.key !== "mobile" && c.key !== "address"
      );

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ReportTable;
